import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Button from "./Button";

const useStyles = makeStyles({
    container: {
        position: "fixed",
        bottom: "0",
        zIndex: "2000",
        background: "#FFFF",
        border: "1px solid #cccc",
        padding: "15px 60px 15px 60px",
    },
    text: {
        fontSize: "1.2rem",
        opacity: "0.7",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        lineHeight: "1.6",
        letterSpacing: "0.0075em",
        textAlign: "justify",
    },
});

export default function Alerta({ history }) {
    const classes = useStyles();
    const [state, setstate] = useState(false);

    const handleClick = ({ acordo }) => {
        if (acordo) {
            localStorage.setItem("acordo", "1");
            setstate(true);
        } else {
            sessionStorage.setItem("acordo", "1");
            setstate(true);
        }
    };

    return state ? null : (
        <div className={classes.container}>
            <div className="mt-2">
                <p className={classes.text}>
                    Este site usa cookies de terceiros do Google Analytics para
                    rastrear visitas na página e eventos. Obtenha mais
                    informações sobre, cookies e termos de uso em{" "}
                    <a
                        href="http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm"
                        target="blank"
                    >
                        LGPD
                    </a>{" "}
                    ,{" "}
                    <a
                        href="https://www.azapfy.com.br/termo-de-uso/"
                        target="blank"
                    >
                        Termos de Uso
                    </a>{" "}
                    e{" "}
                    <a
                        href="https://www.azapfy.com.br/privacy-policy/"
                        target="blank"
                    >
                        Política de Privacidade
                    </a>{" "}
                    neste site. Esta página não envia dados de visualizações de
                    página e eventos sem consentimento e não armazena dados de
                    visitantes. Todos os dados da sessão são armazenados
                    localmente em seu próprio navegador, pelo uso da local
                    storage API. O consentimento pode ser revogado limpando os
                    dados armazenados localmente no seu navegador.
                </p>
            </div>
            <div className="mt-4 mb-2">
                {" "}
                <Button
                    minWidth="175px"
                    color="#FF7418"
                    texto={"ESTOU DE ACORDO"}
                    className="mr-3"
                    onClick={() => handleClick({ acordo: true })}
                />
                <Button
                    minWidth="175px"
                    border="#FF7418"
                    color="#fff"
                    texto={"IGNORAR"}
                    onClick={() => handleClick({ acordo: false })}
                />
            </div>
        </div>
    );
}
